import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  activationMBSRadio: false,
  activationMBSTV: false,
};
